// extracted by mini-css-extract-plugin
export var completionBody = "_gl-2";
export var completionCard = "_gl-0";
export var completionFooter = "_gl-3";
export var completionTitle = "_gl-1";